<template>
  <fo-layout>
    <span slot="alt" v-if="headlineText[4]">{{headlineText[4].sub_title}}</span>
    <span slot="title" v-if="headlineText[4]">{{headlineText[4].title}}</span>
    <div class="home-cases" v-if="data.length">
      <a-row :gutter="30">
        <a-col :sm="12" v-for="(item, ind) in data" :key="ind">
          <div class="backimg centerimage" ref="backimg"
            :style="'background-image: url(' + item.case_poster_url + '); height: ' + height"></div>
          <p class="title black to-2">{{item.case_title}}</p>
          <p class="title-alt to-3 info">{{item.case_sub_title}}</p>
          <a-button class="fo-small-btn fs-16 mt-12" type="primary"
            @click="goToDtl('./practice/cases/' + item.code)">查看详情</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="home-cases" v-else>
      <a-row :gutter="30">
        <a-col :sm="12" v-for="(item, ind) in 2" :key="ind">
          <div class="backimg centerimage gray-bg" ref="backimg"
            :style="'height: ' + height"></div>
          <p class="title black to-2">
            <span class="dis-bl ht-30 gray-bg mb-10"></span>
            <span class="dis-bl ht-30 gray-bg"></span>
          </p>
          <p class="title-alt to-3 info">
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg mb-10"></span>
            <span class="dis-bl ht-20 gray-bg"></span>
          </p>
        </a-col>
      </a-row>
    </div>
  </fo-layout>
</template>

<script>
export default {
  data () {
    return {
      height: '320px',
      headlineText: [],
      loading: false,
      data: [],
      cond: {
        page_num: 1,
        page_size: 2
      }
    }
  },
  mounted () {
    this.readList()
    this.readItems()
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    readItems () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          var data = JSON.parse(r.data.value)
          for (var i of data) {
            if (i.label_en === 'home' || i.label_zh === '网站首页') {
              this.headlineText = i.children
            }
          }
        } else {
          this.error(r.msg)
        }
      })
    },
    readList () {
      this.loading = true
      this.get({
        url: 'casesRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.data = res.data.items
        // 设置背景图高度为宽度的50%
        setTimeout(() => {
          if (this.$refs.backimg[0].clientWidth) {
            this.height = (this.$refs.backimg[0].clientWidth / 100 * 50 + 'px')
          }
        }, 1)
      })
    },
    goToDtl (router) {
      window.scroll(0, 0)
      this.$router.push(router)
    }
  }
}
</script>

<style lang="less">

  /* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .example4 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 440px 50px;
    margin: 20px 0;
  }
  .home-cases {
    margin-top: 20px;
    .title {
      line-height: 26px;
      font-family: Georgia, 宋体;
      font-weight: bold;
      font-size: 18px;
      margin: 10px 0;
    }
    .title-alt {
      font-size: 14px;
      margin-bottom: 20px;
    }
    .backimg {
      width: 100%;
    }
    .fo-small-btn {
      margin-bottom: 30px;
      margin-top: 0;
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .example4 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 340px 50px;
    margin: 20px 0;
  }
  .home-cases {
    .title {
      line-height: 40px;
      font-family: Georgia, 宋体;
      font-weight: bold;
      font-size: 30px;
      margin: 20px 0;
    }
    .title-alt {
      font-size: 16px;
      margin-bottom: 30px;
    }
    margin-top: 80px;
    .backimg {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/cases.vue